import { useCallback, useContext } from 'react';

import { useDatadogContext } from '@/context/hooks/useDatadogContext';

import { LogPageContext, LogPageContextType } from './LogPageContext';

export const useClickLogger = (manualContext?: LogPageContextType) => {
  const { datadogLogs } = useDatadogContext();
  const pageContext = useContext(LogPageContext);
  const [page, metadata] = pageContext ?? manualContext ?? [];
  const handleClick = useCallback(
    (componentName: string, clickMetadata?: object) => {
      // Log the click event
      if (!page) {
        return;
      }
      datadogLogs?.logger.log('click', {
        component: componentName,
        page,
        action: 'click',
        timestamp: Date.now(),
        clickMetadata,
        ...(metadata ? metadata : {}),
      });
    },
    [metadata, page, datadogLogs]
  );

  return handleClick;
};
